import styled from "@emotion/styled"
import Link from "components/Link"

const ArticleAuthorInfoLink = styled(Link)`
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
`

export default ArticleAuthorInfoLink
